var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "d-flex flex-column h-100",
      attrs: { elevation: "0", outlined: "", "min-height": "350" },
    },
    [
      _c(
        "v-card-title",
        {
          staticClass:
            "py-1 white--text d-flex align-center justify-space-between",
          class: _vm.$vuetify.theme.dark ? "black" : "primary",
          staticStyle: { "flex-wrap": "nowrap" },
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex align-center",
              staticStyle: { flex: "1 1 auto", "min-width": "0" },
            },
            [
              _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { color: "white", medium: "" } },
                [_vm._v("skip_next")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "white--text body-font body-1 font-weight-bold text-uppercase text-ellipsis",
                },
                [_vm._v(_vm._s(_vm.$t("dashboards.nextMatchdayGames")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.loading && _vm.games && _vm.games[0]
            ? _c(
                "v-btn",
                {
                  staticClass: "pl-0 pr-0",
                  staticStyle: { "flex-shrink": "0" },
                  attrs: {
                    text: "",
                    small: "",
                    to: {
                      path: "/leagues",
                      query: {
                        leagueId: _vm.games[0].leagueId,
                        tab: "matchdays",
                        matchday: _vm.games[0].matchDay,
                      },
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "white--text text-decoration-underline font-weight-bold",
                    },
                    [_vm._v(_vm._s(_vm.$t("general.seeAll")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    {
                      staticClass: "ml-1",
                      attrs: { small: "", color: "white" },
                    },
                    [_vm._v("keyboard_arrow_right")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        { staticClass: "d-flex flex-column flex-grow-1 pa-0" },
        [
          !_vm.loading
            ? [
                !_vm.games || !_vm.games[0]
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-center align-center flex-column px-3 py-4 mb-13 text-center flex-grow-1",
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            style: {
                              "font-size": _vm.$vuetify.breakpoint.mdAndUp
                                ? "80px"
                                : "60px",
                            },
                            attrs: { color: "primary lighten-5" },
                          },
                          [_vm._v("event_busy")]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "primary--text lighten--text-2 body-1",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "dashboards.placeholderNextMatchDayNotFound"
                                )
                              )
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : [
                      _c(
                        "div",
                        {
                          staticClass:
                            "mt-1 pl-6 pr-4 pt-1 pb-0 d-flex align-center justify-space-between",
                        },
                        [
                          _c("div", { staticClass: "d-flex align-center" }, [
                            _c("img", {
                              staticClass: "mr-1",
                              attrs: {
                                src: `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${_vm.games[0].leagueId}.png`,
                                height: "18",
                                width: "18",
                              },
                              on: { error: _vm.onLeagueImgError },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "subheader-font body-2 primary--text font-weight-bold",
                                staticStyle: { opacity: "1 !important" },
                              },
                              [_vm._v(_vm._s(_vm.games[0].leagueName))]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.games[0].matchDay
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "subheader-font body-2 primary--text font-weight-bold",
                                  staticStyle: { opacity: "1 !important" },
                                },
                                [
                                  _vm._v(
                                    "Matchday " + _vm._s(_vm.games[0].matchDay)
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pr-3 pb-2 pt-1" },
                        _vm._l(_vm.games, function (game, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass:
                                "body-2 pl-6 my-1 d-flex align-center",
                            },
                            [
                              _vm.$vuetify.breakpoint.mdAndUp
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "w-11 text-center",
                                      staticStyle: { "white-space": "nowrap" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "primary--text body-1",
                                          staticStyle: {
                                            "white-space": "nowrap",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getLocalMatchDate(
                                                game.matchDate,
                                                "DD/MM/YYYY"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  staticClass:
                                    "w-35 text-right d-flex align-center justify-end pr-1 primary--text body-1 mw-0",
                                  attrs: { to: `/team/${game.homeTeamId}` },
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("v-img", {
                                        staticClass: "mx-1",
                                        attrs: {
                                          src: game.homeTeamImgError
                                            ? "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png"
                                            : "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/" +
                                              game.homeTeamId +
                                              ".png",
                                          height: 18,
                                          width: 18,
                                        },
                                        on: {
                                          error: function ($event) {
                                            return _vm.onImgError(
                                              $event,
                                              game,
                                              "home"
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(game.homeTeamName)),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "text-center font-weight-bold",
                                  class: {
                                    "w-8": _vm.$vuetify.breakpoint.mdAndUp,
                                    "w-15": !_vm.$vuetify.breakpoint.mdAndUp,
                                  },
                                },
                                [
                                  _c("span"),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "mx-1" }, [
                                    _vm._v("-"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span"),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  staticClass:
                                    "w-35 d-flex align-center pl-1 primary--text body-1 mw-0",
                                  attrs: { to: `/team/${game.awayTeamId}` },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(game.awayTeamName)),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c("v-img", {
                                        staticClass: "mx-1",
                                        attrs: {
                                          src: game.awayTeamImgError
                                            ? "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png"
                                            : "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/" +
                                              game.awayTeamId +
                                              ".png",
                                          height: 18,
                                          width: 18,
                                        },
                                        on: {
                                          error: function ($event) {
                                            return _vm.onImgError(
                                              $event,
                                              game,
                                              "away"
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "flex-shrink-0",
                                  staticStyle: { width: "max-content" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "elevation-0 monospace-font",
                                      attrs: {
                                        block: "",
                                        color: "primary",
                                        to: `/game/${game.gameId}`,
                                        rounded: "",
                                        outlined: "",
                                        "x-small": "",
                                      },
                                    },
                                    [
                                      game.statusId !== 4
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-center",
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$vuetify.breakpoint
                                                      .mdAndUp
                                                      ? _vm.$t(
                                                          "gameAnalysis.seeDetail"
                                                        )
                                                      : ""
                                                  ) +
                                                  "\n                  "
                                              ),
                                              !_vm.$vuetify.breakpoint.mdAndUp
                                                ? _c("v-icon", [
                                                    _vm._v("chevron_right"),
                                                  ])
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      game.statusId === 4
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-center",
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "mr-1 animate-flicker",
                                                  attrs: {
                                                    color: "red",
                                                    small: "",
                                                  },
                                                },
                                                [_vm._v("adjust")]
                                              ),
                                              _vm._v(" "),
                                              _vm.$vuetify.breakpoint.mdAndUp
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("general.live")
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ],
              ]
            : [
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-4 pl-6 pr-4 d-flex align-center justify-space-between",
                  },
                  [
                    _c("v-skeleton-loader", {
                      staticClass: "ma-0",
                      attrs: { type: "text", width: "30%" },
                    }),
                    _vm._v(" "),
                    _c("v-skeleton-loader", {
                      staticClass: "ma-0",
                      attrs: { type: "text", width: "15%" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "px-6 py-4 flex-grow-1 d-flex flex-column justify-space-around",
                  },
                  _vm._l(5, function (i) {
                    return _c("v-skeleton-loader", {
                      key: i,
                      staticClass: "my-2",
                      attrs: { type: "text", width: "100%" },
                    })
                  }),
                  1
                ),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }